import React, { useState, useContext } from "react";
import "../../Style/deletestyle.scss";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import { Stack, Box } from "@mui/material";
import { useMutation } from "@apollo/client";
//Schema
import { AuthContext } from "../../Context/AuthContext";
import { DELETE_DEPARTMENT } from "../../Schema/Department";

export default function DeleteDepartment({
  open,
  handleClose,
  editData,
  setRefetch,
}) {
  const [loading, setLoading] = useState(false);

  const [deleteDepartment] = useMutation(DELETE_DEPARTMENT, {
    onCompleted: ({ deleteDepartment }) => {
      // console.log(deleteDepartment);
      setLoading(false);
      if (deleteDepartment?.success === true) {
        setAlert(true, "success", deleteDepartment?.message);
        handleClose();
        setRefetch();
      } else {
        setAlert(true, "error", deleteDepartment?.message);
      }
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const { setAlert } = useContext(AuthContext);

  const handleDelete = () => {
    setLoading(true);
    deleteDepartment({
      variables: {
        id: editData?._id,
      },
    });
  };

  return (
    <Dialog open={open} className="delete-container">
      <DialogTitle sx={{ padding: "10px 20px" }}>
        <Stack direction="row" spacing={2}>
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">Delete Department</Typography>
          </Stack>
          <Box sx={{ flexGrow: 1 }} />
          <IconButton onClick={handleClose}>
            <CloseIcon className="close-icon" />
          </IconButton>
        </Stack>
      </DialogTitle>

      <DialogContent>
        <Stack direction="row" spacing={1}>
          <Typography>Are you sure to delete this data ?</Typography>
        </Stack>
      </DialogContent>

      <DialogActions>
        <Stack direction="row" spacing={4} className="action-container">
          <Button className="btn-cencel" fullWidth onClick={handleClose}>
            Cencel
          </Button>

          {loading ? (
            <Button className="btn-delete" fullWidth>
              Loading...
            </Button>
          ) : (
            <Button className="btn-delete" fullWidth onClick={handleDelete}>
              Delete
            </Button>
          )}
        </Stack>
      </DialogActions>
    </Dialog>
  );
}
